import { useState } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Label } from '@/components/ui/label'
import { requestMobile } from '@/lib/request'
import { toast } from 'sonner'

interface ClaimRewardDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  accountInfo: {
    plat: string
    remarks_name: string
  }
  onSuccess?: () => void
}

export function ClaimRewardDialog({ open, onOpenChange, accountInfo, onSuccess }: ClaimRewardDialogProps) {
  const [loading, setLoading] = useState(false)
  const [selectedType, setSelectedType] = useState('1')

  const handleClaim = async () => {
    setLoading(true)
    try {
      const resp = await requestMobile('/common/apis/v1/check-vip-gift', {
        plat: accountInfo.plat,
        name: accountInfo.remarks_name,
        type: parseInt(selectedType)
      })

      if (resp && resp.code === 0) {
        toast.success('领取奖励成功')
        onOpenChange(false)
        onSuccess?.()
      }
    } catch (error) {
      console.error('Failed to claim reward:', error)
      toast.error('领取奖励失败')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>领取奖励</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <RadioGroup value={selectedType} onValueChange={setSelectedType}>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="1" id="type-1" />
              <Label htmlFor="type-1">1（晋级）</Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="2" id="type-2" />
              <Label htmlFor="type-2">2（周）</Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="3" id="type-3" />
              <Label htmlFor="type-3">3（月）</Label>
            </div>
          </RadioGroup>

          <div className="flex gap-2">
            <Button
              variant="outline"
              onClick={() => onOpenChange(false)}
              className="flex-1"
            >
              取消
            </Button>
            <Button onClick={handleClaim} disabled={loading} className="flex-1">
              {loading ? '领取中...' : '确认领取'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
